import { ScanDecision, ScanSession } from "./types/ScanHistory.types";

const MAX_DECISIONS = 500;
const MAX_SESSIONS = 50;

const getDecisionsKey = (venueId: string): string =>
  `ai_scan_decisions_${venueId}`;

const getSessionsKey = (venueId: string): string =>
  `ai_scan_sessions_${venueId}`;

export const generateScanSessionId = (): string => {
  try {
    return crypto.randomUUID();
  } catch {
    const array = new Uint32Array(2);
    crypto.getRandomValues(array);
    return (
      Date.now().toString(36) + array[0].toString(36) + array[1].toString(36)
    );
  }
};

export const recordScanDecisions = (decisions: ScanDecision[]): void => {
  if (decisions.length === 0) return;

  const venueId = decisions[0].venueId;
  const key = getDecisionsKey(venueId);

  try {
    const existing = getScanHistory(venueId);
    const combined = [...existing, ...decisions];
    const pruned =
      combined.length > MAX_DECISIONS
        ? combined.slice(combined.length - MAX_DECISIONS)
        : combined;

    localStorage.setItem(key, JSON.stringify(pruned));
  } catch {
    // Storage may be full or unavailable
  }
};

export const recordScanSession = (session: ScanSession): void => {
  const key = getSessionsKey(session.venueId);

  try {
    const existing = getScanSessions(session.venueId);
    const combined = [...existing, session];
    const pruned =
      combined.length > MAX_SESSIONS
        ? combined.slice(combined.length - MAX_SESSIONS)
        : combined;

    localStorage.setItem(key, JSON.stringify(pruned));
  } catch {
    // Storage may be full or unavailable
  }
};

export const getScanHistory = (venueId: string): ScanDecision[] => {
  try {
    const raw = localStorage.getItem(getDecisionsKey(venueId));
    if (!raw) return [];
    return JSON.parse(raw) as ScanDecision[];
  } catch {
    return [];
  }
};

export const getScanSessions = (venueId: string): ScanSession[] => {
  try {
    const raw = localStorage.getItem(getSessionsKey(venueId));
    if (!raw) return [];
    return JSON.parse(raw) as ScanSession[];
  } catch {
    return [];
  }
};

export const clearScanHistory = (venueId: string): void => {
  try {
    localStorage.removeItem(getDecisionsKey(venueId));
    localStorage.removeItem(getSessionsKey(venueId));
  } catch {
    // Storage may be unavailable
  }
};
